<template>
  <Dialog :open="open" @update:open="emit('update:open', $event)">
    <DialogContent class="max-w-md">
      <DialogHeader>
        <DialogTitle>{{ t(`seasonGate.${seasonState}.title`) }}</DialogTitle>
        <DialogDescription as="div" class="space-y-3">
          <p>{{ t(`seasonGate.${seasonState}.description`) }}</p>
          <p v-if="seasonState === 'before_start'">
            <i18n-t keypath="seasonGate.before_start.facebookCta" tag="span">
              <template #facebook>
                <a
                  href="http://fb.me/borowka.szczecin"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="font-medium text-blueberry-dark underline underline-offset-4 hover:text-blueberry"
                >
                  fb.me/borowka.szczecin
                </a>
              </template>
            </i18n-t>
          </p>
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button type="button" @click="emit('update:open', false)">
          {{ t("common.close") }}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@acme/ui";
import type { BlueberrySeasonState } from "@acme/api";
import { useI18n } from "vue-i18n";

withDefaults(
  defineProps<{
    open: boolean;
    seasonState?: Exclude<BlueberrySeasonState, "open">;
  }>(),
  {
    seasonState: "before_start",
  },
);

const emit = defineEmits<{
  (e: "update:open", value: boolean): void;
}>();

const { t } = useI18n();
</script>
